import * as yup from 'yup';

import { Gender } from '@/model';

export const gender = yup
	.string()
	.oneOf(Object.values(Gender))
	.required('Påkrævet');
